import { Injectable, signal } from '@angular/core';

const HEADER_MENUS = {
  language: 'language',
  profile: 'profile'
} as const;

type HeaderMenu = typeof HEADER_MENUS[keyof typeof HEADER_MENUS];

@Injectable({ providedIn: 'root' })
export class HeaderMenuService {
  private readonly activeMenuSignal = signal<HeaderMenu | null>(null);

  isLanguageOpen(): boolean {
    return this.isOpen(HEADER_MENUS.language);
  }

  isProfileOpen(): boolean {
    return this.isOpen(HEADER_MENUS.profile);
  }

  toggleLanguage(): void {
    this.toggle(HEADER_MENUS.language);
  }

  toggleProfile(): void {
    this.toggle(HEADER_MENUS.profile);
  }

  closeLanguage(): void {
    this.closeMenu(HEADER_MENUS.language);
  }

  closeProfile(): void {
    this.closeMenu(HEADER_MENUS.profile);
  }

  close(): void {
    this.activeMenuSignal.set(null);
  }

  private isOpen(menu: HeaderMenu): boolean {
    return this.activeMenuSignal() === menu;
  }

  private toggle(menu: HeaderMenu): void {
    this.activeMenuSignal.update(activeMenu => activeMenu === menu ? null : menu);
  }

  private closeMenu(menu: HeaderMenu): void {
    if (this.activeMenuSignal() === menu) {
      this.activeMenuSignal.set(null);
    }
  }
}
